// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file efibi/v1/hub/common/tenant.proto (package efibi.v1.hub, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file efibi/v1/hub/common/tenant.proto.
 */
export const file_efibi_v1_hub_common_tenant: GenFile = /*@__PURE__*/
  fileDesc("CiBlZmliaS92MS9odWIvY29tbW9uL3RlbmFudC5wcm90bxIMZWZpYmkudjEuaHViIqYBCgZUZW5hbnQSCgoCaWQYASABKAwSDAoEbmFtZRgCIAEoCRISCgpzaG9ydF9uYW1lGAMgASgJEi4KCmNyZWF0ZWRfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg4KBmNvdW50eRgGIAEoCUIVChNmci5lZmliaS5hcGkudjEuaHViYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message efibi.v1.hub.Tenant
 */
export type Tenant = Message<"efibi.v1.hub.Tenant"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string short_name = 3;
   */
  shortName: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string county = 6;
   */
  county: string;
};

/**
 * Describes the message efibi.v1.hub.Tenant.
 * Use `create(TenantSchema)` to create a new message.
 */
export const TenantSchema: GenMessage<Tenant> = /*@__PURE__*/
  messageDesc(file_efibi_v1_hub_common_tenant, 0);

